import React from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";
import store, { rootReducer } from "../../../../store";
import { setRendererFormState } from "../../../../slices/common/reducer";

const PhoneNumber = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
  showRequired = true,
}) => {
  let key = databaseKey ? databaseKey : displayLabelKey;

  const displayYes = fieldEle?.["display-yes"];
  const parentSelectedValue = displayYes ? formState[displayYes] : "";
  const shouldDisplay = parentSelectedValue?.toLowerCase() === "yes";

  if (displayYes && !shouldDisplay) {
    return null;
  }

  const handleInputChange = (e) => {
    let value = e.target.value;

    if (!/^\d*$/.test(value)) {
      return;
    }

    if (value.length > 10) {
      value = value.slice(0, 10);
    }

    rootReducer.dispatch(setRendererFormState({ key, value }));
  };

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element no-arrows"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <input
          id={newElfromJSON}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          className="form-control mandatory"
          type="tel"
          placeholder={fieldEle?.["display-placeholder"]}
          disabled={fieldEle?.["display-disabled"] === 1}
          required={showRequired ? fieldEle?.["display-required"] === 1 : false}
          name={key}
          value={formState[key] || ""}
          pattern="^\d{10}$"
          maxLength={10}
          onChange={handleInputChange}
        />
        <div className="invalid-feedback">This field is required</div>
        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default PhoneNumber;
